import {
  ArrowDownDoubleIcon,
  Building02Icon,
  PlusSignIcon,
  UserAdd01Icon,
  Diamond02Icon,
  UserGroupIcon,
  GridViewIcon,
} from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { useNavigate } from "react-router-dom"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  // useSidebar,
} from "@/components/ui/sidebar"
import { resolveAssetUrl } from "@/lib/asset-url"
import { useWorkspace } from "@/workspaces/WorkspaceContext"

function WorkspaceInitials(name: string) {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("")
}

export function WorkspaceSwitcher() {
  // const { isMobile } = useSidebar()
  const { workspace, workspaces, path } = useWorkspace()
  const navigate = useNavigate()

  return (
    <SidebarMenu className="p-0">
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              style={{ paddingTop: 0, paddingBottom: 0 }}
              className="h-[43px] px-3 rounded-none data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              {workspace.logo_url ? (
                <img
                  src={resolveAssetUrl(workspace.logo_url)}
                  alt={workspace.name}
                  className="flex aspect-square size-6 items-center justify-center rounded-md object-cover"
                />
              ) : (
                <div className="flex aspect-square size-6 items-center justify-center rounded-md bg-sidebar-primary text-sidebar-primary-foreground text-[10px] font-semibold">
                  {WorkspaceInitials(workspace.name)}
                </div>
              )}
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{workspace.name}</span>
              </div>
              <HugeiconsIcon icon={ArrowDownDoubleIcon} strokeWidth={2} className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="min-w-72 rounded-lg"
            align="start"
            side="bottom"
            sideOffset={4}
            alignOffset={8}
          >
            <DropdownMenuLabel className="text-xs text-muted-foreground">
              Workspaces
            </DropdownMenuLabel>
            {workspaces.map((ws) => (
              <DropdownMenuItem
                key={ws.id}
                onClick={() => {
                  window.localStorage.setItem("chrona:last-workspace-slug", ws.slug)
                  navigate(`/${ws.slug}/home`)
                }}
                className="gap-2 p-2"
              >
                {ws.logo_url ? (
                  <img
                    src={resolveAssetUrl(ws.logo_url)}
                    alt={ws.name}
                    className="size-6 rounded-md object-cover"
                  />
                ) : (
                  <div className="flex size-6 items-center justify-center rounded-md border bg-background text-xs font-medium">
                    {WorkspaceInitials(ws.name)}
                  </div>
                )}
                <span className="flex-1 truncate">{ws.name}</span>
                {ws.slug === workspace.slug && (
                  <span className="text-xs text-muted-foreground">✓</span>
                )}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem
                className="gap-2 p-2"
                onClick={() => navigate("/onboarding")}
              >
                <div className="flex size-6 items-center justify-center rounded-md border bg-background">
                  <HugeiconsIcon icon={PlusSignIcon} strokeWidth={2} className="size-4" />
                </div>
                <span className="font-medium">Новая рабочая область</span>
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem className="gap-2 p-2" onClick={() => navigate(path("/settings/general"))}>
                <div className="flex size-6 items-center justify-center rounded-md border bg-background">
                  <HugeiconsIcon icon={Building02Icon} strokeWidth={2} className="size-4" />
                </div>
                <span>Настройки рабочей области</span>
              </DropdownMenuItem>
              <DropdownMenuItem className="gap-2 p-2" onClick={() => navigate(path("/settings/members"))}>
                <div className="flex size-6 items-center justify-center rounded-md border bg-background">
                  <HugeiconsIcon icon={UserAdd01Icon} strokeWidth={2} className="size-4" />
                </div>
                <span>Пригласить участников</span>
              </DropdownMenuItem>
              <DropdownMenuItem className="gap-2 p-2" onClick={() => navigate(path("/settings/billing"))}>
                <div className="flex size-6 items-center justify-center rounded-md border bg-background">
                  <HugeiconsIcon icon={Diamond02Icon} strokeWidth={2} className="size-4" />
                </div>
                <span>Обновить тариф</span>
              </DropdownMenuItem>
              <DropdownMenuItem className="gap-2 p-2" disabled>
                <div className="flex size-6 items-center justify-center rounded-md border bg-background">
                  <HugeiconsIcon icon={UserGroupIcon} strokeWidth={2} className="size-4" />
                </div>
                <span>Порекомендовать команде</span>
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem className="gap-2 p-2" disabled>
                <div className="flex size-6 items-center justify-center rounded-md border bg-background">
                  <HugeiconsIcon icon={GridViewIcon} strokeWidth={2} className="size-4" />
                </div>
                <span>Приложения и интеграции</span>
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
